/**
 * OfflineBadge — fixed top strip surfaced when the device is offline.
 *
 * See docs/pwa-update-and-offline.md §3.3. Visible regardless of SW state;
 * the component reads only `navigator.onLine`, so it is useful today even
 * without the read-offline cache in place — it just lets the user know
 * the network is down.
 *
 * Like VersionGate (§1.5), this component lives as a sibling of
 * <RouterProvider> in main.tsx so it can render above any route. It
 * therefore must NOT call router-context hooks (e.g. useRouterState),
 * which is why no analytics is wired here.
 */
import { useOnlineStatus } from '@/lib/offline/useOnlineStatus'

export function OfflineBadge() {
  const online = useOnlineStatus()
  if (online) return null
  return (
    <div
      data-testid="offline-badge"
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 49, // one below VersionGate (50) so a force-update modal still sits on top
        background: '#1f2937',
        color: '#fff',
        padding: '8px 16px',
        fontSize: 13,
        textAlign: 'center',
        letterSpacing: 0.2,
        boxShadow: '0 1px 4px rgba(0,0,0,0.18)',
      }}
    >
      Você está sem conexão. Mostrando os últimos dados disponíveis.
    </div>
  )
}
